import { useMutation } from '@tanstack/react-query'
import { useNotification } from 'components/Notification'
import { postPeopleMergeReview } from 'services/merge'
import { transformJobMappingsForAPI } from '../utils'
import { formatErrorMessage } from '../utils'

function usePeopleMergeReviewMutation() {
  const { createNotification } = useNotification()

  const {
    data,
    mutateAsync: fetchReview,
    isPending: isLoading,
    isError,
    error,
    reset: clearReview,
  } = useMutation({
    mutationFn: ({ sourceId, targetId, jobMappings }) => {
      const { jobMappings: apiMappings, jobOverrides } = transformJobMappingsForAPI(jobMappings)
      return postPeopleMergeReview(sourceId, targetId, apiMappings, jobOverrides)
    },
    retry: false,
    onError: error => {
      const message = formatErrorMessage(error, 'Failed to load merge preview')
      createNotification({ message, variant: 'error' })
    },
  })

  return {
    data,
    fetchReview,
    isLoading,
    isError,
    error,
    clearReview,
  }
}

export default usePeopleMergeReviewMutation
